<template>
  <transition name="toast-fade">
    <div v-if="visible" class="toast-container">
      <div class="toast-content">{{ message }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ToastMessage",
  data() {
    return {
      visible: false,
      message: "",
      timer: null,
    };
  },
  methods: {
    /**
     * 显示 Toast
     * @param {string} message - 提示消息
     * @param {number} duration - 显示时长（毫秒），默认 2000ms
     */
    show(message, duration = 2000) {
      this.message = message;
      this.visible = true;

      // 清除之前的定时器
      if (this.timer) {
        clearTimeout(this.timer);
      }

      // 设置自动隐藏
      this.timer = setTimeout(() => {
        this.visible = false;
      }, duration);
    },

    /**
     * 隐藏 Toast
     */
    hide() {
      this.visible = false;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
  },
  beforeUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
.toast-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  pointer-events: none;
}

.toast-content {
  background-color: rgba(0, 0, 0, 0.75);
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

// 淡入淡出动画
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.3s ease;
}

.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
}
</style>

